import "@/App.css";
import { Toaster } from "sonner";
import EarthExplorer from "@/components/EarthExplorer";

function App() {
  return (
    <div className="App">
      <EarthExplorer />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(7,12,24,0.92)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#e8eefc",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
}

export default App;
